import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  message,
  Button,
  Radio,
  Checkbox,
} from "antd";
import { URL } from "../helper/Mainurl";

const { Option } = Select;

const EditMemberForm = ({
  visible,
  onCancel,
  member,
  roleMetaData,
  token,
  onUpdate,
  calendarSummary,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (member) {
      form.setFieldsValue({
        nickname: member.nickname || undefined,
        name: member.name || undefined,
        role: Number(member.role_id) || undefined,
        email: member.email || undefined,
        phone: member.phone || undefined,
        has_calendar_access: member.has_calendar_access || false,
      });
    }
  }, [member, form]);

  const handleEditMember = async () => {
    try {
      const values = await form.validateFields();
      if (!values.name || !values.role || !values.email) {
        message.error("Please fill in all required fields.");
        return;
      }
      const memberId = member?.key;
      const requestBody = {
        nickname: values.nickname ? values.nickname.trim() : null,
        new_role: values.role == member?.role_id ? undefined : values.role,
        phone_number: values.phone ? values.phone.trim() : null,
        has_calendar_access: values.has_calendar_access ? 1 : 0,
      };
      //   return
      setLoading(true);
      const response = await fetch(`${URL}/v1/member/update/${memberId}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok && data?.code === 200) {
        message.success("Member updated successfully!");
        onUpdate();
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error(data?.message || "Failed to update member");
      }
    } catch (error) {
      if (error?.errorFields) {
        message.error("Please fill in all required fields correctly.");
      } else {
        message.error(
          error?.message || "Something went wrong. Please try again."
        );
        console.error("Update member error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Edit Member"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="ok"
          type="primary"
          onClick={handleEditMember}
          loading={loading} // shows spinner
          disabled={loading} // disables while loading
        >
          OK
        </Button>,
      ]}
      width={500}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter Name" }]}
        >
          <Input placeholder="Enter Name" disabled />
        </Form.Item>
        <Form.Item
          name="nickname"
          label="Nickname"
          rules={[{ required: false, message: "Please enter nickname" }]}
        >
          <Input placeholder="Enter nickname" />
        </Form.Item>

        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: "Please select role" }]}
        >
          <Select placeholder="Select role">
            {roleMetaData
              .filter((role) => role.name.toLowerCase() !== "admin")
              .map((role) => (
                <Option key={role.id} value={role.id}>
                  {role.name}
                </Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please enter a valid email",
            },
          ]}
        >
          <Input disabled placeholder="Email address" />
        </Form.Item>

        <Form.Item name="phone" label="Phone">
          <Input placeholder="Enter phone number" />
        </Form.Item>

        {calendarSummary && calendarSummary?.remaining_slots > 0 && (
          <Form.Item
            name="has_calendar_access"
            valuePropName="checked" // tells Form to treat `checked` as the
          >
            <Checkbox>Grant Calendar Access</Checkbox>
          </Form.Item>
        )}

        <div className="">
          <p>
            <strong>Calendar access slots remaining</strong>:{" "}
            {calendarSummary?.remaining_slots}
          </p>
        </div>
      </Form>
    </Modal>
  );
};

export default EditMemberForm;
